var _defs, _path, _circle, _circle2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128.57 99.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#da783c;}.c{stroke-width:3.53px;}.c,.d{fill:none;stroke:#da783c;stroke-miterlimit:10;}.d{stroke-width:9.72px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M126.81,31.43v59.08c0,4.18-3.39,7.57-7.57,7.57H9.34c-4.18,0-7.57-3.39-7.57-7.57V31.43c0-4.18,3.39-7.57,7.57-7.57h31.31V6.65c0-2.7,2.19-4.88,4.88-4.88h37.87c2.7,0,4.88,2.19,4.88,4.88V23.86h30.95c4.18,0,7.57,3.39,7.57,7.57Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 64.29,
    cy: 59.43,
    r: 25.85
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 101.62,
    cy: 38.44,
    r: 6.19
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOn);
export default __webpack_public_path__ + "static/media/on.bb191330af42a067de333fa8eb1e6700.svg";
export { ForwardRef as ReactComponent };